// extracted by mini-css-extract-plugin
module.exports = {"errorMessageBox":"error-message_errorMessageBox__8NM1P","button":"error-message_button___xSS6","video":"error-message_video___KH1h","compact":"error-message_compact__YmA_z"};